import { Application, Container } from "pixi.js";

export interface CreateAppOptions {
  width: number;
  height: number;
  backgroundColor?: number;
  resolution?: number;
}

/**
 * Pixi.js v8 Application を生成する非同期関数。
 * WebGL/WebGPU の初期化はすべてここに閉じ込める。
 */
export async function createApp(opts: CreateAppOptions): Promise<Application> {
  const app = new Application();
  await app.init({
    width: opts.width,
    height: opts.height,
    backgroundColor: opts.backgroundColor ?? 0xf4efe6,
    antialias: true,
    resolution: opts.resolution ?? window.devicePixelRatio,
    autoDensity: true,
  });
  return app;
}

/**
 * ステージの層構造。奥から順に:
 *   - world: ワールドの全コンテンツ（パン/ズーム対象）
 *     - groundLayer: 床タイル
 *     - entityLayer: 機械・コンベア・ロボット・ワーク（Zソート対象）
 *     - overlayLayer: デバッグ表示・選択ハイライト
 *   - ui: 画面固定（HUD）
 */
export interface StageLayers {
  world: Container;
  groundLayer: Container;
  entityLayer: Container;
  overlayLayer: Container;
  ui: Container;
}

export function createStageLayers(app: Application): StageLayers {
  const world = new Container();
  const groundLayer = new Container();
  const entityLayer = new Container();
  entityLayer.sortableChildren = true;
  const overlayLayer = new Container();
  const ui = new Container();

  world.addChild(groundLayer);
  world.addChild(entityLayer);
  world.addChild(overlayLayer);

  app.stage.addChild(world);
  app.stage.addChild(ui);

  return { world, groundLayer, entityLayer, overlayLayer, ui };
}
